<!--
使用或引用请注明来源：
作者：谢宝新
电话：13902658317
授权网沛物联使用
-->
<template>
	<div class="keyboard-wrapper">
		<input id="telinput" type="text" v-if="!this.$store.state.isclose" v-model="NUM" @focus="show = true"
			onfocus="this.blur()" placeholder="请输入房间号或电话" />
		<p>{{ initstate }}</p>
		<img class="logo" :src="imgsrclogo" />
		<p>智慧社区</p>
		<p v-if="this.$store.state.isclose">
			<b style="color: green">呼叫开门通话已结束</b>
		</p>
		<div class="keyboard" v-else>
			<div class="num" id="keybd" v-show="!isShowSelect">
				<table>
					<tr>
						<td @click="change(1)" :class="[active === 1 ? 'active' : '']" @touchstart="msDown(1)"
							@touchend="msUp(1)">
							1
						</td>
						<td @click="change(2)" :class="[active === 2 ? 'active' : '']" @touchstart="msDown(2)"
							@touchend="msUp(2)">
							2
						</td>
						<td @click="change(3)" :class="[active === 3 ? 'active' : '']" @touchstart="msDown(3)"
							@touchend="msUp(3)">
							3
						</td>
					</tr>
					<tr>
						<td @click="change(4)" :class="[active === 4 ? 'active' : '']" @touchstart="msDown(4)"
							@touchend="msUp(4)">
							4
						</td>
						<td @click="change(5)" :class="[active === 5 ? 'active' : '']" @touchstart="msDown(5)"
							@touchend="msUp(5)">
							5
						</td>
						<td @click="change(6)" :class="[active === 6 ? 'active' : '']" @touchstart="msDown(6)"
							@touchend="msUp(6)">
							6
						</td>
					</tr>
					<tr>
						<td @click="change(7)" :class="[active === 7 ? 'active' : '']" @touchstart="msDown(7)"
							@touchend="msUp(7)">
							7
						</td>
						<td @click="change(8)" :class="[active === 8 ? 'active' : '']" @touchstart="msDown(8)"
							@touchend="msUp(8)">
							8
						</td>
						<td @click="change(9)" :class="[active === 9 ? 'active' : '']" @touchstart="msDown(9)"
							@touchend="msUp(9)">
							9
						</td>
					</tr>
					<tr>
						<td class="del" @click="del">×</td>
						<td @click="change(0)" :class="[active === 0 ? 'active' : '']" @touchstart="msDown(0)"
							@touchend="msUp(0)">
							0
						</td>
						<td id="comfirm" class="comfirm" @click="comfirm">确定</td>
					</tr>
				</table>
			</div>

			<div class="selectperson" v-show="isShowSelect">
				<h3 class="F7">请选择呼叫对象</h3>
				<div class="por">
					<div class="selectBox" style="width: 100%;">
						<input type="hidden" name="unit" v-model="unitModel">
						<div class="selectBox_list"
							style="height: 380px; width: 100%;overflow-y: scroll; display: block;background-color: #118eeb;">
							<div class="selectBox_listLi" v-for="(item, index) in dataList" :key="index"
								@click.stop="select(item, index)">{{item.realName.replace(/(\d{3})\d{4}(\d{4})/, '\$1****\$2')}}[{{item.encryptPhone}}]
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="okto" id='okto' @click="comfirm">呼叫</div>
	</div>
</template>

<script>
	import imga_logo from "../assets/logo.png";
	const axios = require("axios");
	// const baseaxurl = "http://39.108.78.21:7602/device/dcit/api/eq/v1/";
	// const baseaxurl = "https://localhost:8080/jeecg-boot/device/dcit/api/eq/v1/";
	const baseaxurl = "https://admin.bzy2015.com/jeecg-boot/device/dcit/api/eq/v1/";

	export default {
		name: "Start",
		data() {
			return {
				imgsrclogo: imga_logo,
				active: null,
				show: false,
				NUM: "",
				result: [],
				deviceid: "",
				isShowSelect: false,
				talkTime: 1,
				dataList: [],
				unitName: '请选择对象',
				unitModel:0,

			};
		},
		computed: {
			num: function() {
				return this.result.join("");
			},
			initstate() {
				return this.$store.state.callinfo.doorname;
			},

		},
		created() {

		},
		mounted() {

			var devid = this.getQueryString("dvid");

			if (!devid.startsWith('TC')) {
				// 如果不是，添加 'TC' 前缀
				devid =  'TC' + devid;
			}
			this.deviceid = devid;
			this.$store.state.deviceId = devid;
			this.$store.state.callinfo.remoteurl = baseaxurl;


			var tonum = this.getQueryString("to");
			if (tonum != null && tonum >= 0) {
				var keybd = document.getElementById("keybd");
				var telinnode = document.getElementById("telinput");
				var okto = document.getElementById("okto");

				if (telinnode != null)
					telinnode.style.display = 'none';
				if (keybd != null)
					keybd.style.display = 'none';

				okto.style.display = 'block';
				this.NUM = tonum;
			}


			var toability = this.getQueryString("ability");
			if (toability != null && toability >= 0) {
				this.$store.state.ability = toability;
			}

			this.getunitinfo(devid);

		},
		methods: {

			processString(url) {
				// 使用正则表达式匹配 dvid 参数的值
				const match = url.match(/dvid=(\d+)/);

				if (match && match[1]) {
					let dvid = match[1];

					// 检查是否已经以 'TC' 开头
					if (!dvid.startsWith('TC')) {
						dvid = 'TC' + dvid;
					}

					return dvid;
				}

				// 如果没有匹配到 dvid，返回原始 URL
				return url;
		},


			msDown(v) {
				this.active = v;
			},
			msUp(v) {
				this.active = "";
				console.log(v);
			},
			stopInput() {
				return false;
			},
			change(val) {
				if (this.result.length === 0 && val === ".") {
					return false;
				} else {
					this.result.push(val);
					this.NUM = this.result.join("");
				}
			},
			del() {
				this.result.pop();
				this.NUM = this.result.join("");
				this.$emit("del", this.NUM);
			},
			getQueryString(name) {
				var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
				var reg_rewrite = new RegExp("(^|/)" + name + "/([^/]*)(/|$)", "i");
				var r = window.location.search.substr(1).match(reg);
				var q = window.location.pathname.substr(1).match(reg_rewrite);
				if (r != null) {
					return unescape(r[2]);
				} else if (q != null) {
					return unescape(q[2]);
				} else {
					return null;
				}
			},
			getQueryVariable(variable) {
				var query = window.location.search.substring(1);
				var vars = query.split("&");
				for (var i = 0; i < vars.length; i++) {
					var pair = vars[i].split("=");
					if (pair[0] == variable) {
						return pair[1];
					}
				}
				return false;
			},
			getunitinfo(device_id) {
				var param = {
					deviceId: device_id
				};
				axios({
						method: "get",
						url: "get-appid",
						baseURL: baseaxurl,
						headers: {
							"Access-Control-Allow-Origin": "*",
							"Content-Type": "application/x-www-form-urlencoded",
						},

						data: param,
						params: param,
					})
					.then((res) => {
						console.log("get-appid", res.data);
						if (res.data.retCode == 200) {

							var doorname = res.data.data.doorname;
							document.title = doorname;
							this.$store.state.callinfo.doorname = doorname;

							this.$store.state.talkTime = res.data.data.talkTime;

							this.imgsrclogo =res.data.data.logo;

							if (res.data.data.url != '') {
								this.$store.state.callinfo.remotemqtturl = res.data.data.url;
							}
						} else {
							alert(res.data.message);
							return;
						}
					})
					.catch((error) => {
						console.log(error);
					});
			},

			comfirm() {
				if (this.NUM == "") return;

				if (this.$store.state.isclose) {
					alert("呼叫已关闭，请重新扫码进入！");
					return;
				}
				var mobreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
				var rmreg0 = /^[0-9]{4}$/;
				var rmreg1 = /^[0-9]{8}$/;
				var rmreg2 = /^[0-9]{3}$/;
				if (
					mobreg.test(this.NUM) ||
					rmreg0.test(this.NUM) ||
					rmreg1.test(this.NUM) ||
					rmreg2.test(this.NUM)
				) {
					if (this.NUM.length == 3)
						this.NUM = "0" + this.NUM;

					this.$emit("comfirm", this.NUM);
					this.show = false;
				} else {
					alert("输入非法");
					return;
				}

				var confirmbt = document.getElementById("comfirm");
				confirmbt.style.display = 'none';

				var param = {
					deviceId: this.$store.state.deviceId,
					roomtel: this.NUM,
					// ability:this.$store.state.ability
				};
				axios({
						method: "post",
						url: "phone-call-list",
						baseURL: this.$store.state.callinfo.remoteurl,
						headers: {
							"Access-Control-Allow-Origin": "*",
							"Content-Type": "application/x-www-form-urlencoded",
						},

						data: param,
						params: param,
					})
					.then((res) => {
						console.log("phone-call return", res.data);
						if (res.data.retCode == 200) {
							this.$store.state.callinfo.meid = res.data.data.meid;
							this.$store.state.callinfo.server = res.data.data.server;

							this.$store.state.callinfo.doorname = res.data.data.doorname;
							this.$store.state.callinfo.roomtel = this.NUM;

							if (res.data.data.phone == '' || res.data.data.phone == null) {
								this.isShowSelect = true;
								this.dataList = res.data.data.phoneList;
							} else {
								this.$store.state.callinfo.phone = res.data.data.phone;
								this.$store.state.callinfo.peerid = res.data.data.phone;
								this.$store.state.login = true;
							}
						}
						if (res.data.retCode == 400) {
							alert(res.data.message);
							return;
						}
					})
					.catch((error) => {
						console.log(error);
					});
			},

			select(item, index) {
				this.isShowSelect = false;
				var tphone = this.dataList[index].phone;
				this.unitModel = index;
				this.unitName = tphone;

				this.$store.state.callinfo.phone = tphone;
				this.$store.state.callinfo.peerid = tphone;
				this.$store.state.login = true;
			}

		},
	};
</script>
<style lang="less" scoped>
	.logo {
		width: 20vw;
		height: 20vw;
	}

	.selectBox_listLi {
		margin-bottom: 8px;
		text-align: center;
		line-height: 60px;
		background-color: rgba(0, 0, 0, 0.1);
		color: #eee;
	}

	.selectBox_listLi:active {
		background-color: #f93;
	}

	.keyboard-wrapper {
		height: 100vh;
		background-color: #fff;
		user-select: none;

		input {
			width: 97%;
			height: 50px;
			font-size: 25px;
			margin: 1% 1%;
		}

		.keyboard {
			position: fixed;
			bottom: 0;
			width: 100%;

			.num {
				table {
					width: 100%;
					border: 1px solid #ccc;
					border-collapse: collapse;
					background: #fff;

					td {
						height: 50px;
						width: 30%;
						vertical-align: middle;
						color: #333;
						font-size: 20px;
						border: 1px solid #ccc;
						text-align: center;
					}

					td.active {
						background: #ccc;
					}

					.del {
						background: #eee;
					}

					.comfirm {
						font-size: 16px;
						width: 80px;
						background: #118eeb;
						color: #fff;
					}


				}
			}
		}

		.okto {
			position: fixed;
			display: none;
			height: 20vw;
			width: 20vw;
			border-radius: 50%;
			border: 1px solid #ffeb3b;
			background-color: #2196f3;
			bottom: 10vh;
			left: 40vw;
			color: white;
			line-height: 20vw;
			font-weight: 600;
		}
	}
</style>
